<template>
  <div>
    <vue-loading v-if="loading"></vue-loading>
    <div v-else>
      <div v-if="dataAvailable === false">
        <router-link :to="{ name: 'sync' }" tag="button" class="btn btn-turquois qm-survey-edit-button">
          <i class="fa fa-fw fa-cloud-upload"></i>
          Synchronize with the Server
        </router-link><br /><br />
      </div>
      <div v-else>
        <h1>
          Surveys
        </h1>
        <router-link :to="{ name: 'sync' }" tag="button" class="btn btn-turquois qm-survey-edit-button">
          <i class="fa fa-fw fa-cloud-upload"></i>
          Synchronize with the Server
        </router-link><br /><br />
        <ul v-if="surveys.length >  0" class="list-group qm-survey-list">
          <li class="list-group-item-heading">
            <div class="col-sm-4 col-md-4 col-lg-1">
              <i class="fa fa-fw fa-star-half-o"></i> Status
            </div>
            <div class="col-sm-4 col-md-4 col-lg-2">
              <i class="fa fa-fw fa-calendar"></i> Date
            </div>
            <div class="col-sm-4 col-md-4 col-lg-2">
              <i class="fa fa-fw fa-clock-o"></i> Time
            </div>
            <div class="col-sm-4 col-md-12 col-lg-3">
              <i class="fa fa-fw fa-user-circle-o"></i> Client
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
              <i class="fa fa-fw fa-home"></i> Address
            </div>
          </li>
          <li v-for="survey in surveys" @click="goToSurvey(survey)" class="list-group-item" v-bind:class="{ closed: survey.closed }">
            <div class="col-sm-4 col-md-4 col-lg-1">
              <div v-if="!survey.opened && !survey.closed && !survey.deleted">New</div>
              <div v-else-if="survey.opened && !survey.closed && !survey.deleted">Opened</div>
              <div v-else-if="survey.opened && survey.closed && !survey.deleted">Closed</div>
              <div v-else-if="survey.opened && survey.closed && survey.deleted">Deleted</div>
              <div v-else>Unknown</div>
            </div>
            <div class="col-sm-4 col-md-4 col-lg-2 date">{{ survey.surveyDate | formatDate }}</div>
            <div class="col-sm-4 col-md-4 col-lg-2 time">{{ survey.surveyTime | formatTime }}</div>
            <div class="col-sm-4 col-md-12 col-lg-3 name">{{ survey.clientFirstName }} {{ survey.clientLastName }}</div>
            <div class="col-sm-12 col-md-12 col-lg-4 address">{{ survey['address-01'] }} {{ survey['address-02'] }} {{ survey['address-03'] }}, {{ survey.postcode }} {{ survey.city }}</div>
          </li>
        </ul>
        <div v-else>
          <p>No Surveys available</p>
        </div>
      </div><br /><br />
      <router-link v-if="session.debug" :to="{ name: 'import' }" tag="button" class="btn btn-turquois qm-survey-edit-button"><i class="fa fa-cloud-download"></i> Import Example Data</router-link>
      <router-link v-if="session.debug" :to="{ name: 'debug' }" tag="button" class="btn btn-turquois qm-survey-edit-button"><i class="fa fa-gear"></i> Debug Mode</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Surveys',
  data: () => ({
    dataAvailable: false,
    surveys: [],
    loading: true
  }),
  computed: {
    ...mapGetters({
      session: 'getSession'
    })
  },
  created: function () {
    this.$store.dispatch('loadSession').then(() => {
      this.$store.dispatch('loadActiveSurveys').then(() => {
        let surveys = this.$store.getters.getAllSurveys
        surveys = surveys.filter(survey => {
          if (!survey.deleted) {
            return true
          }
          console.log('skipped deleted survey')
          return false
        })
        this.surveys = this.orderSurveyList(surveys)
        this.dataAvailable = true
        this.loading = false
      })
    })
  },
  methods: {
    goToSurvey: function (survey) {
      this.$store.dispatch('selectSurvey', Number(survey.surveyId)).then(() => {
        this.$store.dispatch('setSurveyAsOpened', survey).then(() => {
          this.$router.push({ name: 'survey' })
        })
      })
    },
    orderSurveyList (surveys) {
      surveys.sort(function (a, b) {
        var dateA = new Date(a.surveyDate)
        var dateB = new Date(b.surveyDate)
        return dateA - dateB
      })
      return surveys
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Surveys.vue